import React from 'react';
import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import TestSeriesCard from './TestSeriesCard';
import { useTestSeriesData } from './useTestSeriesData';
import F1AndF2Filters from './F1AndF2Filters';

const TestSeriesSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  scroll-margin-top: 100px;
  gap: 24px;
  align-items: center;
  justify-content: center;
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 64px;
  line-height: 120%;
  letter-spacing: -2%;
  text-align: center;
  color: var(--color-primary-focus);
  margin-bottom: 40px;

  ${mediaQuery.uptoMobile} {
    font-size: 40px;
  }
`;

const TestSeriesCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  gap: 120px;
  width: 100%;
  justify-content: center;
  align-items: center;

  ${mediaQuery.uptoMobile} {
    gap: 40px;
  }
`;

const TestSeriesSection = () => {
  const { data, testSeriesSectionTitle, filteredCardsToShow } =
    useTestSeriesData();

  if (!data) return null;

  return (
    <TestSeriesSectionWrapper id="test-series">
      <Title>{testSeriesSectionTitle}</Title>
      <F1AndF2Filters />
      <TestSeriesCardContainer>
        {filteredCardsToShow.map((item, idx) => {
          const { id, f1, f2 } = item;
          return <TestSeriesCard key={id + f1 + f2 + idx} cardData={item} />;
        })}
      </TestSeriesCardContainer>
    </TestSeriesSectionWrapper>
  );
};

export default TestSeriesSection;
